export default __webpack_public_path__ + "yukari.png";